import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AddressService } from '../services/address/address.service';
import { LoggerService } from '../services/logger/logger.service';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressSearchComponent implements OnInit {


  public data: any[]=[];


  constructor(private addressService: AddressService,
    private loggerService:LoggerService) { }

  ngOnInit() {
    // console.log("addr search,ngOnInit");
    
}
  ngOnChanges() {
    // console.log(`addr search,ngOnChanges - data is ${this['data']}`);
}
  ngAfterViewInit() {
    // console.log("addr search,ngAfterViewInit");
  }
  
  ngAfterContentInit() {
  // console.log("addr search,ngAfterContentInit");
  }
  ngAfterContentChecked() {
  // console.log("addr search,ngAfterContentChecked");
  }
  ngAfterViewChecked() {
    // console.log("addr search,ngAfterViewChecked");
    }

  public filterChange(filter: any): void {


  } 
}
